import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Menu from 'components/Menu';
import { FormTitle, VcEGrid, VcGrid } from 'components/Grid';
import Input from 'components/Material/Input';
import WarehouseModal from 'components/Modal/WareHouseModal';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';
import { userTypeList, localeTw, isType, isTypeBK } from 'main_consts';
import { Iobject } from 'main_type';
import {
  blobDownload,
  getSearch,
  snackBarRsp,
  confirm,
  deleteItem,
  upload,
  getSample,
  getExcel,
  postSearch,
  postExcel,
} from 'main_api';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, GridOptions } from 'ag-grid-community';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ClearIcon from '@material-ui/icons/Clear';
import RefreshIcon from '@material-ui/icons/Refresh';
import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Header from 'components/Header';
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import CheckBox from 'components/Material/Checkbox';
import {
  getExpressName,
  getDateDayPlus,
  inputChange,
  getWarehouse,
  initWhrehhouse,
  formatDate,
  getEhuFunctionChk,
  EhuFunctionChkResult,
} from '../../../main_func';
import { Iresult, Imaster } from './type';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
  })
);
/** 貨櫃卸存清單維護 */
const CarRegisterToWhitelistMtn = (): JSX.Element => {
  const classes = useStyles();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [formError, setFormError] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const apiName = 'carRegisterToWhitelistMtn';
  const [rowData, setRowData] = useState<Iresult[]>([]);
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [warehouseName, setWarehouseName] = useState('');
  const [randomValue, setRandomValue] = useState(Math.random());
  const [random, setRamdom] = useState(Math.random());

  const masterDefaultValue: Imaster = {
    // 貨棧業者
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : 'TPEE011S',

    pageSize: 100,
    enterDateStart: getDateDayPlus(),
    enterDateEnd: getDateDayPlus(),
    enterDateStartValid: true,
    enterDateEndValid: true,
    carNo: '',
    driverNo: '',
    containerNo: '',
    whiteList:
      isType(userTypeList.admin, userType) ||
      isType(userTypeList.type8, userType)
        ? 'Y'
        : 'N',
  };
  const [master, setMaster] = useState(masterDefaultValue);

  const [QueryOK, setQueryOK] = useState(false);
  const [enableDel, setEnableDel] = useState<boolean>(false);
  const [enableConfirm, setEnableConfirm] = useState<boolean>(false);

  useEffect(() => {
    getEhuFunctionChk().then((item) => {
      if (
        userType &&
        !(
          isType(userTypeList.admin, userType) ||
          isTypeBK(userType) ||
          isType(userTypeList.topType, userType) ||
          isType(userTypeList.type1, userType) ||
          isType(userTypeList.type2, userType) ||
          isType(userTypeList.type8, userType) ||
          isType(userTypeList.type4, userType) ||
          isType(userTypeList.type10, userType)
        )
      ) {
        setFormError(true);
        enqueueSnackbar(`您無權限使用此功能!`);
      }
    });
    setMaster((prev) => ({
      ...prev,
      warehouse: masterDefaultValue.warehouse,
      whiteList: masterDefaultValue.whiteList,
    }));
  }, [userType]);

  function onCellEditingStartedEvent(event: any) {
    // console.log('onCellEditingStarted(local):', event);
    switch (event.colDef.field) {
      case 'declDate':
        // setTimeout(() => {
        //   if (isType(userTypeList.type1, userType)) {
        //     event.api.stopEditing(true);
        //   }
        // }, 0);
        break;
      default:
        break;
    }
  }
  const gridRef = useRef<any>(undefined);
  const getColumnDefs = (): ColDef[] => {
    return [
      {
        checkboxSelection: false,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '車號',
        field: 'carNo',
        width: 300,
      },
      {
        headerName: '進出站日期',
        field: 'enterDate',
        width: 300,
      },
      {
        headerName: '進出站類型',
        field: 'enterType',
        width: 300,
      },
      {
        headerName: '進出站狀態',
        field: 'enterStatusName',
        width: 150,
      },
      {
        headerName: '司機姓名',
        field: 'driver',
        width: 150,
      },
      {
        headerName: '司機身份證號',
        field: 'driverNo',
        width: 300,
      },
      {
        headerName: '貨櫃號碼',
        field: 'containerNo',
        width: 300,
      },
      {
        headerName: '助手姓名',
        field: 'driverAide',
        width: 300,
      },
      {
        headerName: '助手身份證號',
        field: 'driverAideNo',
        width: 300,
      },
      {
        headerName: '通運公司',
        field: 'logisticName',
        width: 300,
      },
      {
        headerName: '結束日期',
        field: 'endDate',
        width: 300,
      },
      {
        headerName: '備註',
        field: 'remark',
        width: 300,
      },
      {
        headerName: '板箱號',
        field: 'truckNo',
        width: 300,
      },
      {
        headerName: '拋轉註記',
        field: 'sendFlag',
        width: 300,
      },
      {
        headerName: '資料異動時間',
        field: 'updtime',
        width: 300,
      },
      {
        headerName: '處理說明',
        field: 'processDesc',
        minWidth: 250,
        cellStyle: (params) => {
          if (params && params.data.processDesc === '寫檔成功!') {
            return { fontWeight: 'initial', color: 'black' };
          }
          return { fontWeight: 'bold', color: 'red' };
        },
      },
    ];
  };
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs();

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: false,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
      onCellEditingStarted: onCellEditingStartedEvent,
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
  };
  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));

      console.log('enterDateStart', master.enterDateStart);
      console.log('enterDateEnd', master.enterDateEnd);
      const result = await postSearch(apiName, {
        warehouse: master.warehouse,
        enterDateStart: master.enterDateStart,
        enterDateEnd: master.enterDateEnd,
        driverNo: master.driverNo,
        carNo: master.carNo,
        containerNo: master.containerNo,
      });
      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }

      const carDTOs =
        (result.data.data as { carDTOs?: Iresult[] })?.carDTOs ?? [];
      const data: Iresult[] = carDTOs;
      if (data) {
        if ((data || []).length > 0) {
          setRowData(data);
          setOpenSearchTable(true);

          setEnableDel(true);
        } else {
          setEnableDel(false);
          setOpenSearchTable(false);
        }
      } else {
        setOpenSearchTable(false);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleSample = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    try {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(setLoadingRedux(true));

      const result = await getSample(apiName, {
        whiteList: master.whiteList === 'Y' ? 'Y' : 'N',
      });

      blobDownload(
        result,
        enqueueSnackbar,
        `入出站登錄作業-快遞平台匯入範本.xlsx`
      );
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
  };

  const handleUpload = async (
    file: File,
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    try {
      dispatch(setLoadingRedux(true));
      await gridRef.current?.api.stopEditing(true);

      const formData = new FormData();
      formData.append('execlFile', file);

      const result = await upload(apiName, formData);

      if (!snackBarRsp(enqueueSnackbar, result)) {
        dispatch(setLoadingRedux(false));
        return;
      }

      const carDTOs =
        (result.data.data as { carDTOs?: Iresult[] })?.carDTOs ?? [];
      const data: Iresult[] = carDTOs;

      if ((data || []).length > 0) {
        setEnableDel(false);

        setRowData(data);
        setEnableConfirm(true);
        setOpenSearchTable(true);
        console.log('EnableDel', enableDel);
      } else {
        setEnableConfirm(false);
        setEnableDel(false);
        setOpenSearchTable(false);
        console.log('EnableConfirm', enableConfirm);
      }
      setRandomValue(Math.random());
      dispatch(setLoadingRedux(false));
    } catch (error) {
      dispatch(setLoadingRedux(false));
    }
    console.log('setEnableDel', enableDel);
    console.log('setEnableConfirm', enableConfirm);
  };
  const selectFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = (e.target as HTMLInputElement).files?.item(0); // 取得選中檔案們的一個檔案

    if (file) {
      handleUpload(file);
    }
    e.target.value = '';
  };

  const handleDeleteItem = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    try {
      dispatch(setLoadingRedux(true));
      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: Iresult[] = [];
      if (rowData && rowData.length > 0) {
        rowData.forEach((node: any) => {
          const itemDataResult: Iresult = {
            warehouse: master.warehouse,
            carNo: node.carNo,
            // enterDate: '2025/08/08',
            enterDate: node.enterDate,
            enterType: node.enterType,
            enterStatusName: node.enterStatusName,
            enterStatus: node.enterStatus,
            driver: node.driver,
            driverNo: node.driverNo,
            containerNo: node.containerNo,
            driverAide: node.driverAide,
            driverAideNo: node.driverAideNo,
            logisticName: node.logisticName,
            // endDate: '2025/08/09',
            endDate: node.endDate,
            remark: node.remark,
            truckNo: node.truckNo,
            processDesc: node.processDesc,
            enterDateStart: '',
            enterDateEnd: '',
            proceDesc: '',
            sendFlag: node.sendFlag,
            updtime: node.updtime,
            enterDateStartValid: false,
            enterDateEndValid: false,
          };
          return rowDataCRUD.push(itemDataResult);
        });

        const result = await deleteItem(apiName, {
          confirmDetails: rowDataCRUD,
        });
        if (!snackBarRsp(enqueueSnackbar, result)) {
          dispatch(setLoadingRedux(false));
          return;
        }
        console.log('result', result);
        const carDTOs =
          (result.data.data as { carDTOs?: Iresult[] })?.carDTOs ?? [];
        const data: Iresult[] = carDTOs;
        if (data) {
          if ((data || []).length > 0) {
            console.log('data', data);
            setRowData(data);
            setOpenSearchTable(true);
          } else {
            setOpenSearchTable(false);
          }
        } else {
          setOpenSearchTable(false);
        }
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先查詢資料');
        return;
      }
    } catch (error) {
      console.error('handleConfirm error:', error);
      dispatch(setLoadingRedux(false));
      enqueueSnackbar('執行失敗，請稍後再試');
    }
    dispatch(setLoadingRedux(false));
  };

  const handleConfirm = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    try {
      dispatch(setLoadingRedux(true));
      await gridRef.current.api.stopEditing(false);

      const rowDataCRUD: Iresult[] = [];
      if (rowData && rowData.length > 0) {
        rowData.forEach((node: any) => {
          const itemDataResult: Iresult = {
            warehouse: master.warehouse,
            carNo: node.carNo,
            // enterDate: '2025/08/08',
            enterDate: node.enterDate,
            enterType: node.enterType,
            enterStatus: node.enterStatus,
            enterStatusName: node.enterStatusName,
            driver: node.driver,
            driverNo: node.driverNo,
            containerNo: node.containerNo,
            driverAide: node.driverAide,
            driverAideNo: node.driverAideNo,
            logisticName: node.logisticName,
            // endDate: '2025/08/09',
            endDate: node.endDate,
            remark: node.remark,
            truckNo: node.truckNo,
            processDesc: node.processDesc,
            enterDateStart: '',
            enterDateEnd: '',
            proceDesc: '',
            sendFlag: node.sendFlag,
            updtime: node.updtime,
            enterDateStartValid: false,
            enterDateEndValid: false,
          };
          return rowDataCRUD.push(itemDataResult);
        });

        const result = await confirm(apiName, { confirmDetails: rowDataCRUD });
        if (!snackBarRsp(enqueueSnackbar, result)) {
          dispatch(setLoadingRedux(false));
          return;
        }
        console.log('result', result);
        const carDTOs =
          (result.data.data as { carDTOs?: Iresult[] })?.carDTOs ?? [];
        const data: Iresult[] = carDTOs;
        if (data) {
          if ((data || []).length > 0) {
            console.log('data', data);
            setRowData(data);
            setOpenSearchTable(true);

            setEnableDel(false);
          } else {
            setEnableDel(false);
            setOpenSearchTable(false);
          }
        } else {
          setOpenSearchTable(false);
        }
      } else {
        dispatch(setLoadingRedux(false));
        enqueueSnackbar('請先上傳資料');
        return;
      }
    } catch (error) {
      console.error('handleConfirm error:', error);
      dispatch(setLoadingRedux(false));
      enqueueSnackbar('執行失敗，請稍後再試');
    }
    dispatch(setLoadingRedux(false));
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    setEnableConfirm(false);
    setEnableDel(false);
    // if (master.carNo.length === 0) {
    //   master.insertDate = getDateDayPlus();
    // }
    // if (!master.dateValid || !master.warehouseValid) {
    //   return;
    // }
    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'confirm':
        if (window.confirm('是否確定存檔？')) {
          handleConfirm();
        }
        break;
      case 'deleteItem':
        if (window.confirm('是否確定刪除？')) {
          handleDeleteItem();
        }
        //  handleDeleteItem();
        break;
      case 'getSample':
        handleSample();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    console.log('updateObj', updateObj);
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      setFormError(warehouseResult.error);
    }
  };

  const selectPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        // console.log('index2', index2);
        for (index = index3; index < index2; index += 1) {
          // console.log('index', index);
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          // console.log('rowNode', rowNode);
          if (rowNode) {
            rowNode.setSelected(true, false);
          }
        }
        // console.log('index2', index2);
        // console.log('index', index);
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      // console.log('firstIdx', firstIdx);
      // console.log('lastIdx', lastIdx);
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const selectNoPage = async () => {
    // console.log(gridRef.current!.api.paginationGetCurrentPage());
    // gridRef.current!.api.forEachNode((node: any, index: number) =>
    //   node.setSelected(!!node.data && node.data.year !== 2012)
    // );
    // let lastIndex: number;
    // let maxIndex :number;
    if (gridRef.current) {
      const setRangeSelected = async (
        firstIndex: number,
        lastIndex: number
      ) => {
        let index = lastIndex;
        let index2 = lastIndex;
        let index3 = firstIndex;

        const maxIndex: number =
          gridRef.current.api.paginationGetRowCount() as number;
        if (lastIndex > maxIndex) {
          index2 = maxIndex;
        }
        index3 = 0;

        // console.log('index2', index2);
        for (index = index3; index < index2; index += 1) {
          // console.log('index', index);
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(index);
          // console.log('rowNode', rowNode);
          if (rowNode) {
            rowNode.setSelected(false, false);
          }
        }
        // console.log('index2', index2);
        // console.log('index', index);
      };
      // 取得當前頁數第一筆
      const firstIdx =
        gridRef.current.api.paginationGetCurrentPage() *
        gridRef.current.api.paginationGetPageSize();
      // 取得當前頁數最後一筆
      const lastIdx: number =
        firstIdx + gridRef.current.api.paginationGetPageSize();
      // 設定範圍選取
      // console.log('firstIdx', firstIdx);
      // console.log('lastIdx', lastIdx);
      setRangeSelected(firstIdx, lastIdx);
    }
  };

  const handleReset = async () => {
    await gridRef.current?.api.stopEditing(true);
    setRamdom(Math.random());
    setMaster(masterDefaultValue);

    setEnableConfirm(false);
    setEnableDel(false);
    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
    setQueryOK(false);
    setEnableDel(false);
  };
  return (
    <div id="page-area">
      <Header />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 車輛入出站登錄查詢與上傳
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>日期區間：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
              <DateSePickersTyping
                required
                updateData={updateData}
                style={{ maxWidth: 600 }}
                names={['enterDateStart', 'enterDateEnd']}
                data={master}
                seInterval={31}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              車號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={12}
                value={master.carNo}
                name="carNo"
                onChange={(e) => {
                  // 取得當前的輸入值
                  const inputValue = e.target.value;
                  // 將值轉換為大寫
                  e.target.value = inputValue.toUpperCase();
                  // 呼叫你的 inputChange 函式
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              身份證號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={12}
                value={master.driverNo}
                name="driverNo"
                onChange={(e) => {
                  // 取得當前的輸入值
                  const inputValue = e.target.value;
                  // 將值轉換為大寫
                  e.target.value = inputValue.toUpperCase();
                  // 呼叫你的 inputChange 函式
                  inputChange(updateData)(e);
                }}
              />
            </Grid>

            {(isType(userTypeList.admin, userType) ||
              isType(userTypeList.type8, userType)) && (
              <VcGrid item xs={12} sm={2}>
                <CheckBox
                  label="白名單"
                  disabled={isType(userTypeList.type8, userType)}
                  checked={master.whiteList === 'Y'}
                  name="whiteList"
                  onChange={() => {
                    // 切換狀態
                    const newValue = master.whiteList === 'Y' ? '' : 'Y';
                    setMaster({ ...master, whiteList: newValue });
                  }}
                />
              </VcGrid>
            )}
          </Grid>

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              櫃號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={12}
                value={master.containerNo}
                name="containerNo"
                onChange={(e) => {
                  // 取得當前的輸入值
                  const inputValue = e.target.value;
                  // 將值轉換為大寫
                  e.target.value = inputValue.toUpperCase();
                  // 呼叫你的 inputChange 函式
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          {!(
            isType(userTypeList.type4, userType) ||
            isType(userTypeList.topType, userType)
          ) && (
            <>
              <VcEGrid item xs={12} sm="auto">
                <Button
                  disabled={!enableConfirm || formError}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<SaveIcon />}
                  onClick={() => setSubmitKey('confirm')}
                >
                  確定
                </Button>
              </VcEGrid>
              <VcEGrid item xs={12} sm="auto">
                <Button
                  disabled={!enableDel || formError}
                  type="submit"
                  variant="contained"
                  color="primary"
                  startIcon={<DeleteForeverIcon />}
                  onClick={() => setSubmitKey('deleteItem')}
                >
                  刪除
                </Button>
              </VcEGrid>

              <Grid item xs={12} sm="auto">
                <input
                  disabled={formError}
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  className={classes.input}
                  id="contained-button-file"
                  // multiple
                  type="file"
                  onChange={selectFile}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    disabled={formError}
                    variant="contained"
                    color="default"
                    startIcon={<AttachFileIcon />}
                    component="span"
                    style={{
                      borderRadius: '20px',
                      // backgroundColor: 'blue',
                    }}
                  >
                    上傳EXCEL
                  </Button>
                </label>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Button
                  disabled={formError}
                  type="submit"
                  variant="outlined"
                  color="primary"
                  startIcon={<SaveIcon />}
                  onClick={() => setSubmitKey('getSample')}
                >
                  下載EXCEL格式範本
                </Button>
              </Grid>
            </>
          )}
        </Grid>
        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          車號格式；請輸入英文及數字ex:AB1234
        </div>
      </form>

      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '500px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
          />
        </div>
      )}
    </div>
  );
};

export default CarRegisterToWhitelistMtn;
